export enum OrderByDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}
